export const REQUEST_VALID_CODE_FACEBOOK = 'REQUEST_VALID_CODE_FACEBOOK'